require('mobile_helpers')

Directory = LP.module 'Directory'
Collections = LP.module 'Collections'

import CollectionBuilder from 'js/collections/builder/init'
import posthog from 'posthog-js';
import { PH_EVENTS } from 'js/posthog_analytics'
import HowdyBoxStatic from 'js/searches/howdy_box/howdy_box_static';

toggleMobileDirectoryWidgets = ->
  $(".widget-heading").click ->
    $(this).parent().toggleClass('open')

attachCaretListeners = ->
  $('.subcategory-toggle').click ->
    $this = $(this)
    $this.parent().children('ul.fa-ul').toggle()
    if $this.hasClass('fa-caret-right')
      $this.removeClass('fa-caret-right').addClass('fa-caret-down')
    else
      $this.removeClass('fa-caret-down').addClass('fa-caret-right')

removeCaretListeners = ->
  $('.subcategory-toggle').off()

openModal = (element) ->
  $('#directory-modal .panel-contents').html(element.parent().parent().children('.panel-contents').html())
  $('#directory-modal li a').removeClass('not-clickable')
  $('#directory-modal li.hidden-category').removeClass('js-hide')
  attachCaretListeners()
  $('#directory-modal').removeClass('js-hide')
  document.body.style.overflow = 'hidden'

closeModal = ->
  removeCaretListeners()
  $('#directory-modal').addClass('js-hide')
  document.body.style.overflow = 'auto'

attachModalListeners = ->
  $('.open-modal').click ->
    $this = $(this)
    openModal($this)
  $('.close-modal').click ->
    closeModal()
  $(document).keyup (e) ->
    if(e.keyCode == 27)
      closeModal()
  $('.react-modal').click (e) ->
    e.stopPropagation()
  $('.react-modal-overlay').click ->
    closeModal()

Directory.index = ->
  posthog.capture(PH_EVENTS.SITE.VISITED_DIRECTORY_PAGE)
  attachModalListeners()

Directory.show = ->
  attachCaretListeners()

  $('.search-result i[rel=tooltip]').tooltip()
  LP.module('DirectoryTermSuggestions').form()
  LP.module('Searches').minimalSearch()
  LP.module('MobileHelpers').bindBackToTopButton()
  LP.module("Analytics").trackVirtualPageSuccess()
  toggleMobileDirectoryWidgets()

  if LP.config.ai_teachers_tools_howdy_box_enabled
    howdyBoxContainer = document.getElementById('howdy-box');
    ReactDOM.createRoot(howdyBoxContainer).render(
      React.createElement(HowdyBoxStatic)
    );

  new CollectionBuilder() if LP.config.is_user_active
